export default {"src":"/_next/static/media/emptyGraph_solid.c5eab2ae.svg","height":76,"width":364,"blurWidth":0,"blurHeight":0};